import React, { Component } from 'react';
import { connect } from 'react-redux';
import PatientForm from '../../../components/authorised/patient/account/PatientForm'
import { patientTemplateLoad } from '../../../redux/actions/public/PatientTemplateActions';
import { patientEdit } from '../../../redux/actions/patient/patientActions';
import { insurancesLoad } from '../../../redux/actions/public/InsuranceActions';
import { tabChange } from '../../../itrust_common/redux/actions/otherActions'
import { appointmentCreate } from '../../../redux/actions/public/AppointmentActions';
import { submit, change } from 'redux-form';
import { SaveButton } from '../../../itrust_common/components/others';
import { initializePatientTemplateAttributes } from '../../../itrust_common/components/HelperFunctions';
import * as $ from 'jquery'
import { MultiSelect } from '../../../itrust_common/components/form';
import DateFormatView from '../../../itrust_common/components/others/DateFormatView';
import { orgConfigLoad } from '../../../itrust_common/redux/actions/settingActions/orgConfigActions';

class PatientRegistration extends Component {
  constructor(props) {
    super(props);
    this.handlePatientFormLoad();
    this.props.dispatch(orgConfigLoad());
    this.props.dispatch(insurancesLoad({ rpp: 1000 }));
  }
  async handlePatientFormLoad(id) {
    var patientTemplate = await this.props.dispatch(patientTemplateLoad());
    var patientData = initializePatientTemplateAttributes(patientTemplate.value.data.patient_template.personal_information)
    this.props.dispatch(patientEdit(id, patientData));
  }
  handleChangeTimeSlot() {
    this.props.dispatch(tabChange({ anonymous: 1 }))
  }
  remoteSubmit() {
    this.props.dispatch(submit('patientForm'))
  }
  handleAppointmentSubmit(data) {
    const { storeId, selectedDate, slot } = this.props
    var appointmentData = {
      appointment: {
        store_id: storeId,
        staff_id: slot.doctor_id,
        start_day: selectedDate,
        end_day: selectedDate,
        start_time: slot.start_time,
        end_time: slot.end_time,
        procedure_ids: data.procedure_ids,
        appointment_type: 'anonymous'
      },
      patient: { ...data }
    }
    new Promise((resolve, reject) => {
      this.props.dispatch(appointmentCreate(appointmentData))
        .then(res => this.props.dispatch(tabChange({ anonymous: 3 })))
    })
  }
  mouseover(color) {
    $('#change-time-btn').css({ "background-color": `${color}`, "border-color": `${color}`, "color": 'white' })
  }
  mouseout(color) {
    $('#change-time-btn').css({ "background-color": "white", "border-color": `${color}`, "color": `${color}` })
  }
  render() {
    const { saving, slot, anonymousSetting: { button_and_link_color, background_color }, procedures, store } = this.props
    return (
      <div className="pb-9" style={{ backgroundColor: background_color }}>
        <div className="border border-2 bg-white mx-auto" style={{ maxWidth: '67rem' }}>
          <div className="row mx-0 border-bottom border-bottom-2 py-4 align-items-center">
            <div className="col-md-6 col-12 mb-md-0 mb-6">
              <div className="d-flex align-items-center">
                <h6>You are booking appointment for</h6>
                <span className="text-muted ml-3"><i className="la la-sm la-clock mr-2" />
                  <DateFormatView dateTime={slot.start_time} timezone={store.timezone} />
                </span>
              </div>
            </div>
            <div className="col-md-6 col-12 text-left">
              <div className="d-flex justify-content-end align-items-center">
                <div className="d-flex flex-column reason-visit-width">
                  <MultiSelect
                    placeholder="Select procedure"
                    onSelectHook={(values) => this.props.dispatch(change('patientForm', 'procedure_ids', values))}
                    label="Reason of Visit"
                    data={procedures}
                    textField="name"
                    valueField="settings_procedure_id"
                    isSearchVisible={true}
                    isAllSelectVisible={false}
                    wrapperClasses="w-75"
                  />
                </div>
                <buttom
                  id={'change-time-btn'}
                  className="btn btn-outline-primary mx-5 text-nowrap"
                  style={{ color: `${button_and_link_color}`, borderColor: `${button_and_link_color}`, backgroundColor: 'white' }}
                  onClick={this.handleChangeTimeSlot.bind(this)}
                  onMouseOver={this.mouseover.bind(this, button_and_link_color)}
                  onMouseOut={this.mouseout.bind(this, button_and_link_color)} >
                  Change Time
                </buttom>
                <SaveButton saving={saving} label="Save Appointment" handleOnClick={this.remoteSubmit.bind(this)} buttonClasses="text-nowrap" />
              </div>
            </div>
          </div>
          <div className="anonymous-calendar-container row mx-0 py-5 pb-9 mx-auto" style={{ maxWidth: '50rem' }}>
            <div className="col-12">
              <PatientForm isLongForm={false} onSubmit={this.handleAppointmentSubmit.bind(this)} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  const { publicAppointment, publicStore } = state
  return {
    slot: publicAppointment.slot,
    store: publicStore.store,
    saving: publicAppointment.saving,
  };
};
export default connect(mapStateToProps)(PatientRegistration);